export const multiselectTokens = {
  multiselect: {
    root: {
      background: '{formField.background}',
      disabledBackground: '{formField.disabledBackground}',
      filledBackground: '{formField.filledBackground}',
      filledHoverBackground: '{formField.filledHoverBackground}',
      filledFocusBackground: '{formField.filledFocusBackground}',
      borderColor: '{formField.borderColor}',
      hoverBorderColor: '{formField.hoverBorderColor}',
      focusBorderColor: '{formField.focusBorderColor}',
      invalidBorderColor: '{formField.invalidBorderColor}',
      color: '{formField.color}',
      disabledColor: '{formField.disabledColor}',
      placeholderColor: '{formField.placeholderColor}',
      invalidPlaceholderColor: '{formField.invalidPlaceholderColor}',
      shadow: 'none',
      paddingX: '0.75rem',
      paddingY: '0.25rem',
      borderRadius: '{borderRadius.sm}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      },
      transitionDuration: '{transition.duration}'
    },

    dropdown: {
      width: '2.5rem',
      color: '{primary.color}'
    },
    overlay: {
      background: '{overlay.select.background}',
      borderColor: '{overlay.select.borderColor}',
      borderRadius: '{borderRadius.sm}',
      color: '{overlay.select.color}',
      shadow: '0 4px 18px 0 rgba(53, 67, 88, 0.08)'
    },
    list: {
      padding: '0.5rem',
      gap: '0.125rem',
      header: {
        padding: '0.5rem 0.5rem 0.5rem 1.25rem'
      }
    },
    option: {
      focusBackground: '{surface.300}',
      selectedBackground: '{surface.0}',
      selectedFocusBackground: '{formField.filledFocusBackground}',
      color: '{surface.1000}',
      focusColor: '{surface.1000}',
      selectedColor: '{surface.1000}',
      selectedFocusColor: '{surface.1000}',
      padding: '0.5rem 0.75rem',
      borderRadius: '{borderRadius.sm}',
      gap: '0.5rem',
      group: {
        background: '{surface.100}',
        color: '{surface.1000}',
        fontWeight: '600',
        padding: '0.5rem 0.75rem'
      }
    },
    chip: {
      borderRadius: '{borderRadius.sm}'
    },
    clearIcon: {
      color: '{surface.700}'
    },
    emptyMessage: {
      padding: '0.5rem 0.75rem'
    }
  }
};

export type MultiSelectTokens = typeof multiselectTokens;
